// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-table th.transfer-month-day,\n.el-table td.transfer-month-day {\n  width: 12em;\n}", ""]);
// Exports
module.exports = exports;
